import {
    VideoLoader
} from 'www/modules/video/video-loader';
import { PlayListAPI } from './filmstrip/recap-filmstrip';
import { Playlist } from '../recap/playlist';
import { RecapTemp } from '../recap/recap-temp';
import { getImageServer } from 'www/utils/get-image-server';
import { StickyVideo } from '../common/sticky-video/sticky-video';
import { CommonSVPLoadModule as SVPLoader } from '../../../../modules/svpload/common-svp-load-module';
import { CloseCaptionReconfig } from '../recap/close-caption';
import { PodcastApiHooks } from './podcast-api-hook';
class Indiscussion {
    constructor() {
        this.podcastHooks = new PodcastApiHooks();
        this.articleID = "";
        this.artilceType = "";
        this.pagevideo = {};
        this.bundleJS;
        this.videoSequence = [];
        this.nextVideoUrl = "";
        this.recapTemp = new RecapTemp();
        this.sponsoredVideo;
        window.timeStamp=[];
        this.PlayerReadyCallbacks = [];
        this.isSVPLoaded = false;
        this.payload;
        this.isAdServedOrWaitReached = false;
        this.isPreRoll;
        this.sticky;
        this.ccReconfig = new CloseCaptionReconfig();
        this.isIfiFirst = this.checkDirectIfi();
        this.skipIfi;
    }

    get player() {
        if (this._player == null) {
            let container = document.querySelector('.streaming-video-player');
            if (container != null) {
                this._player = container.amp;
            }
        }
        return this._player;
    }
    set player(player = null) {
        this._player = player;
    }
    init() {
        this.skipIfi = this.isIfiFirst ? new SkipIfiIndiscussion() : "";
        this.loadVideo().then(event => {
                this.isSVPLoaded = true;
                this.sticky = new StickyVideo("#eed-video .svp-module", $("h1.title").text())
                this.sticky.init();
                if(this.payload) this.playPrerollVideo(this.payload);
                else{
                    setTimeout(() =>{
                        if(!this.payload){
                            console.log("Even after 5 secs no Ad served event on the page, hence editorial video triggered.");
                            this.playPrerollVideo({});
                            wmdPageLink('vid-perf_ifi|timeout');
                        }
                    }, 5000);
                }
            },
            error => {
                console.error("Load Video Error:", error);
            });
    }
    loadVideo() {

        let tracking = {
            moduleName: "vidrecap"
        }

        let videoEl = document.querySelector('[data-module="streaming-video-player"]');
        let videoLoader = new VideoLoader(videoEl, tracking);
        let promise = new Promise((resolve, reject) => {
            videoLoader.load()
                .then((configData) => {
                        let {
                            videoSettings,
                            controlsSettings,
                            apiData
                        } = configData;
                        this.videoApiData = apiData;
                        videoSettings.videoId = "video1";
                        const ccvideoSettings =  this.ccReconfig.reconfiguireCcConfig(apiData, "eed-video");
                        videoSettings = Object.assign({}, ccvideoSettings, videoSettings);                      
                        this._controlsSettings = controlsSettings;
                        this.videoSettings = videoSettings;
                        this.pagevideo = videoSettings;
                        this._videoEl = videoEl;
                        this._tracking = tracking;
                        let svpLoader = new SVPLoader();
                        svpLoader.loadSVPLibrary().then(res => {
                            resolve();
                        })
                    }, //End  video library Code
                    error => {
                        videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
                        reject(error);
                    })
        });
        return promise;
    }

    playPrerollVideo(payload = "") {
        let self = this;
        this.videoSequence = [];
        this.payload = payload;
        this.isAdServedOrWaitReached = true;
        if(!this.isSVPLoaded){
            // console.log("Ad served config event on page but SVP not yet loaded, waiting for load complete status");
            return;
        }

        if (this.pagevideo) {
            this.videoSequence.push("pageVideo");
        }
        const longForm = typeof payload["long-form"] === "undefined" ? null : payload["long-form"];
        if (longForm !== null && typeof longForm.enable !== 'undefined' && longForm.enable ) {
        
            if(!this.isIfiFirst) {
                this.videoSequence.push("ifi");
            }
            this.ifiVideo = longForm;
            if(this.ifiVideo["video"].title == undefined) this.ifiVideo["video"].title = this.ifiVideo.title;
            this.ifiVideo["video"]["playlist"] = typeof longForm["playlist"] != 'undefined' ? longForm["playlist"] : "";
            this.ificonfig = {
                "isIfi": true,
                "isPlaylist": true,
                "title": this.ifiVideo["title"],
                "link": "",
                "thumbnail": this.ifiVideo["playlist"]["thumbnail"],
                "video": "",
                "jobCode": this.ifiVideo["playlist"]["jobCode"]
            }
        }
        const shortForm = typeof payload["short-form"] === 'undefined' ? null : payload["short-form"];
        if(shortForm !== null && typeof shortForm.enable !== 'undefined' && shortForm.enable){
            this.videoSequence.unshift("preroll");
            if(payload["short-form"]["video"].title == undefined) payload["short-form"]["video"].title = payload["short-form"].title;
            this.prerollVideo = payload["short-form"]["video"];
        }
        const teaser = typeof payload["editorial-teaser"] === 'undefined' ? null : payload["editorial-teaser"];
        
        if(teaser !== null && typeof teaser.enable !== 'undefined' && teaser.enable){
            this.videoSequence.unshift("teaser");
            if(payload["editorial-teaser"]["video"].title == undefined) payload["editorial-teaser"]["video"].title = payload["editorial-teaser"].title;
            this.teaserVideo = payload["editorial-teaser"]["video"];
        }
        let playVideo = this.teaserVideo ? this.teaserVideo : (this.prerollVideo ? this.prerollVideo: this.pagevideo);
        if(this.isIfiFirst && longForm !== null && typeof longForm.enable !== 'undefined' && longForm.enable) {
            this.videoSequence.unshift("ifi");
            playVideo = Object.assign({}, this.ifiVideo, this.ifiVideo["video"]);
        }
        if(playVideo && playVideo.videoId === 'preroll-video') this.isPreRoll = playVideo.videoId;
        this.videoSequence.shift();
        let svp = new Medscape.modules.StreamingVideoPlayer(this._videoEl, playVideo, this._tracking);
        this.sticky.setStickyTitle(playVideo.title ? playVideo.title : "" )
        window.svp = svp;
        self.SVP = svp;
        svp.create().then(event => {
                self.amp = event.player;
                this.addPlayerEventlistner(event.player);
                if(this.isIfiFirst &&  playVideo.videoId.indexOf('ifi') > -1) {
                    this.skipIfi.addSkip("#eed-video");
                    $(".eed-skip-button").click(() => {
                        this.skipIfiInner();
                        this.skipIfi.closeSkip();
                    });
                }
                let playListApi = new PlayListAPI();
                const bucketId = $("#bucketCollectionId").length > 0 ? $("#bucketCollectionId").val().split(',')[0] : (typeof window.bucketCollectionId == "string" || typeof window.bucketCollectionId == "number") ? window.bucketCollectionId : "";
                if (bucketId !="") {
                    try {
                        playListApi.callApi(bucketId).then((data) => {
                            if (data["articles"]) {
                                let _playListApi = playListApi.createIndiscussionPlaylist(data["articles"]);
                                this.playlistVideos = _playListApi["playlist"] ? _playListApi["playlist"] : "";
                                this.nextVideoTitle = _playListApi["nextVideoTitle"] ? _playListApi["nextVideoTitle"] : "";
                                this.initIndex =  (_playListApi["initIndex"] != undefined) ? _playListApi["initIndex"] : "";
                                this.nextVideoUrl = _playListApi["nextVideoUrl"] ? _playListApi["nextVideoUrl"]: "";
                                this._createIndiscussionPlaylist();
                                if (typeof this.ifiVideo == "object" && !this.isIfiFirst) {
                                    this.sticky.setIFIVideo(this.ifiVideo["video"].title, ".content-container.ifi .flex-content");
                                } else if(this.isIfiFirst &&  playVideo.videoId.indexOf('ifi') > -1) {
                                    this.sticky.setStickyTitle(this.ifiVideo, true, true);
                                    this.sticky.setCurrentVideo(this.pagevideo.title ? this.pagevideo.title : "", '.indiscussion-editorial');
                                    $(".eed-skip.persistant .eed-skip-button").click(() => {
                                        this.skipIfi.closeSkip();
                                        this.skipIfiInner();
                                    });
                                    this.loadIFIContent(this.ifiVideo , this.isIfiFirst);
                                } else {
                                    this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
                                }
                            }
                        });
                    } catch (error) {
                        console.log('error', error);
                    }
                    this._createIndiscussionPlaylist();
                }
                return event;
            },
            error => {
                videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
            })
    }

    addPlayerEventlistner(player) {
        window.timeStamp = [0, 25, 50, 75, 100];
        window.svp._amp.AmpEventsSources["timeupdate"].subscribe(e => {
            let {
                currentTime, duration
            } = e.state;
            var vidData = "";
            const {
                videoId
            } = e.metadata;
            let timePercent = (currentTime / duration) * 100;
            switch (videoId) {
                case "editorial-teaser":
                    vidData = this.teaserVideo;
                    break;
                case "preroll-video":
                    vidData = this.prerollVideo;
                    break;
                case "ifi":
                    vidData = this.ifiVideo.video;
                    break;
                default:
                    break;
            }

            window.timeStamp = vidData ? window.timeStamp : [];
            if (window.timeStamp.length > 0) {
                window.timeStamp.forEach((element, i) => {
                    if (timePercent > element) {
                        window.timeStamp.splice(i, 1);
                        if (element == 0 && vidData[`trackingPixel-Start`]) {
                            this.loadTrackingPixel(vidData[`trackingPixel-Start`]);
                        } else if (vidData[`trackingPixel-${element}`]) {
                            this.loadTrackingPixel(vidData[`trackingPixel-${element}`]);
                        }
                    }
                });
            }
        });
        window.svp._amp.AmpEventsSources["ended"].subscribe(e => {
            this.playSequence();
        });
    }

    _createIndiscussionPlaylist() {
        let loadIfiContent = false;
        if(this.ifiVideo && this.ificonfig) {
        if(!this.playlistVideos || this.playlistVideos.length === 0) {
                this.playlistVideos = [];
                const playListObj = {
                    "isIfi": false,
                    "isPlaylist": false,
                    "link": ``,
                    "title": this.pagevideo.title,
                    "thumbnail": this.pagevideo["bumperImage"],
                    "playlist": {
                      "thumbnail": this.pagevideo["bumperImage"],
                      "header": "",
                      "title": this.pagevideo["title"]
                    },
                    "video": ""
                  }
                this.playlistVideos.push(playListObj);
            }
            this.playlistVideos.splice((this.initIndex ? this.initIndex : 0) + 1, 0, this.ificonfig);
            if(this.isIfiFirst) {
                this.sticky.setStickyTitle(this.ifiVideo["video"], true, true);
                this.sticky.setCurrentVideo(this.pagevideo.title ? this.pagevideo.title : "", '.indiscussion-editorial');
                loadIfiContent = true;
                $(".eed-skip.persistant .eed-skip-button").click(() => {
                    this.skipIfiInner();
                    this.skipIfi.closeSkip();
                });
            }
        }
        if ($(".playlist-container").length > 0) {
            $(".playlist-container").remove();
        }
        if(!this.playlistVideos || this.playlistVideos.length === 0) {
            return;
        }
        var playlistHtml = this.playlistVideos.map((elem) => {
            let {
                isIfi,
                isPlaylist,
                link,
                thumbnail,
                title,
                jobCode
            } = elem;
            const _jobCode = jobCode ? jobCode: "";
            if (thumbnail.startsWith("en/")) {
                thumbnail = thumbnail.replace("en/", "");
            }

            if( !thumbnail.startsWith("http") && !thumbnail.startsWith("//")){
                thumbnail = `//${getImageServer()}/${thumbnail}`;
            }
            return `<div class="recap-playlist-item ${!isPlaylist && !isIfi && !this.isPreRoll && !this.isIfiFirst ? "now-playing" : ""} ${isIfi && this.isIfiFirst ? "now-playing" : ""}">
            <a class="video-item ${isIfi ? "indiscussion-ifi" : ""} ${!isPlaylist && !isIfi ? "indiscussion-editorial" : ""}" href=${!isPlaylist || isIfi ? "javascript:void(0)" : link}>
               <div class="content-container ${isIfi ? "ifi" : ""}">
                  <div class="flex-content">
                     <div class="image-container" style="background-image: url('${thumbnail}');">
                     </div>
                  </div>
                <div class="meta-data">
                    ${isIfi ? '<div class="header"><span>INFORMATION FROM INDUSTRY</span></div>' : ""}
                    <div class="playlist-title"><span>${title}</span></div>
                    ${isIfi ? `<div class="job-code"><span>${_jobCode}</span></div>`: ""}
                </div>
            </div>
            </a>
         </div>`
        });
        playlistHtml = `<div class="playlist-container"><div class="recap-playlist-module theme-dark">${playlistHtml.join("")}</div></div>`
        $("#eed-video").append(playlistHtml);
        this.recapTemp.createCarousel(this.initIndex);
        this.addEventListnerPlaylist();
        let headingEl = document.querySelector('.title-area .heading');
        headingEl.classList.add('theme-dark');
        headingEl.classList.add('has-playlist');
        setTimeout(()=>{
            $(".recap-playlist-module").addClass("ready");
        },10);
        if(loadIfiContent) this.loadIFIContent(this.ifiVideo, this.isIfiFirst);
    }

    addEventListnerPlaylist() {
        const onFilmStripClick = (type) =>{
            if($(".now-playing").length > 0) $(".now-playing").removeClass("now-playing");
            const nextVideo = (type === 'ifi') ? this.ifiVideo["video"]: this.pagevideo;
            if(type === 'ifi'){
                window.timeStamp = [0, 25, 50, 75, 100];
                this.videoSequence = [];
                this.loadIFIContent(this.ifiVideo);
                $(".indiscussion-ifi").parent().addClass("now-playing");
                if(this.isIfiFirst) {
                    this.skipIfi.closeSkip();
                }
            }
            else {
                this.videoSequence = this.videoSequence.filter((v)=> v === 'ifi');
                $(".sponsored-content-container").remove();
                $(".indiscussion-editorial").parent().addClass("now-playing");
                this.sticky.setStickyTitle(nextVideo.title);
                if (typeof this.ifiVideo == "object" && !this.isIfiFirst) {
                    this.sticky.setIFIVideo(this.ifiVideo["video"].title, ".content-container.ifi .flex-content");
                } else {
                    this.skipIfi.closeSkip();
                    this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
                }
            }
            window.svp.setMedia(nextVideo);
            const npIndex = (type === 'ifi') ? this.initIndex+1: this.initIndex;
            // $(`.recap-playlist-item:eq(${npIndex})`).addClass("now-playing");
        }

        $(".indiscussion-ifi").click((e) => {
            onFilmStripClick("ifi");
        });
        $(".indiscussion-editorial").click((e) => {
            onFilmStripClick("video");
        });
    }
    loadTrackingPixel(trackPix) {
        const timestamp = new Date().getTime().toString();
        const trackPixWithTimeStamp = trackPix.replace("[timestamp]", timestamp);
        const trackImg = `<img src=${trackPixWithTimeStamp} height="1" width="1" alt="Advertisement">`;
        if(trackPix) {
            $("#eed-video").append(trackImg);
        }
    }

    loadIFIContent(nextVideo, ififirst = false){
        if ($('.sponsored-content-container').length > 0) {
            $('.sponsored-content-container').remove();
        }
        const {"html-content": htmlContent, title, theme} = nextVideo;
        const themeClass = (theme == 'dark'? 'theme-dark':'');

        const isiHtmlContent = `<div class="sponsored-content-container ${themeClass} show">
                                    <div class="sponsored-html-content">
                                        ${htmlContent}
                                    </div>
                                    <div class="sponsored-meta-data">
                                        <div class="label">Information From Industry</div>
                                        <div class="title">${title}</div>
                                    </div>
                                </div>`;
        $("div.playlist-container").before(isiHtmlContent);
        if (ififirst) return; 
        this.sticky.setStickyTitle(nextVideo,true);
        this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
    }

    checkDirectIfi () {
        const __url = new URL(window.location.href);
        const _c = __url.searchParams.get("ifi");
        if (typeof _c !== 'undefined' && _c !== null) {
            return true;
        }
        return false;
    }

    skipIfiInner () {
        this.playSequence();
    }

    playSequence () {
        if(this.isIfiFirst && this.ifiVideo) {
            this.skipIfi.closeSkip();
        }
        if ($('.sponsored-content-container').length > 0) {
            $('.sponsored-content-container').remove();
        }
        if (this.videoSequence.length > 0) {
            const nextPriority = this.videoSequence[0];
            let nextIndex;
            let nextVideo;
            if ($(".now-playing").length > 0) $(".now-playing").removeClass("now-playing");
            if (['teaser', 'preroll', 'pageVideo'].indexOf(nextPriority) > -1) {
                nextIndex = this.initIndex;
                nextVideo = nextPriority === 'teaser' ? this.teaserVideo : nextPriority === 'preroll' ? this.prerollVideo : this.pagevideo;
                $(".sponsored-content-container").remove();
                if(nextPriority === 'pageVideo' && this.isIfiFirst) {
                    $(".indiscussion-editorial").parent().addClass("now-playing");
                    this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
                }
            }
            else if (nextPriority === 'ifi') {
                nextIndex = this.initIndex + 1;
                nextVideo = this.ifiVideo["video"];
                this.loadIFIContent(this.ifiVideo);
            }
            if(nextPriority !== 'preroll') $(`.recap-playlist-item:eq(${nextIndex})`).addClass("now-playing");
            window.svp.setMedia(nextVideo);
            this.videoSequence.shift();
            window.timeStamp = [0, 25, 50, 75, 100];

            this.sticky.setStickyTitle(nextPriority !== 'ifi'?(nextVideo.title ? nextVideo.title : ""):this.ifiVideo,nextPriority !== 'ifi'?false:true);
        }
        else if (this.nextVideoUrl) {
            window.location.href = this.nextVideoUrl;
        }
    }
}

class SkipIfiIndiscussion {
    constructor() { }

    init(ref = "") {
        this.addSkip();
        this.nextVidRef = ref;
    }
    addSkip() {
        let _streamingPlayer = $(".streaming-video-player.amp-player");
        let _skipButton = `<div class="eed-skip">
      <p class="eed-skip-text">Program will commence after this Information from Industry.</p>
      <button class="eed-skip-button">Skip</button>
      <div class="close"></div>
      </div>`;
        if (_streamingPlayer.length == 1) {
            _streamingPlayer.append(_skipButton);
            $(".eed-skip .close").click(() => {
                this.closeSkip();
            });
        }
    }
    closeSkip() {
        $(".eed-skip").hide();
        const _persistant = $(".persistent-header.skip");
        if (_persistant.length > 0) {
            _persistant.removeClass("skip");
        }
    }
}
export {
    Indiscussion
}
